import type { SamenvattingGroep } from "./Samenvatting";

/**
 * Een reeks omzetten naar een oplopend totaal — de "Cumulatief"-schakelaar uit de filterbalk.
 *
 * <p>Bij een instroom van 12, 9 en 15 per maand wordt dat 12, 21 en 36: hoeveel er tot en met die
 * maand zijn binnengekomen. Handig om te zien of je het tempo van vorig jaar haalt.
 *
 * <p><b>Bij twee assen loopt de optelling per reeks en niet over alles heen.</b> Staat er per maand
 * én per diersoort uitgesplitst, dan hoort de lijn van "Hond" alleen honden op te tellen. Alles op
 * één hoop zou een grafiek opleveren waarin elke soort de vorige lijkt te overtreffen, puur omdat
 * hij later in de lijst staat.
 *
 * <p><b>Alleen bij aantallen.</b> Gemiddelden optellen levert een getal op dat nergens op slaat —
 * de som van 43,5 en 21,0 zegt niets over de dieren eronder. De aanroeper hoort de schakelaar dan
 * niet aan te bieden; deze functie weigert het ook zelf, want een verkeerd cumulatief cijfer ziet
 * er precies zo overtuigend uit als een goed.
 */
export function cumuleer(
  groepen: SamenvattingGroep[],
  maat: "AANTAL" | "GEMIDDELDE" = "AANTAL",
): SamenvattingGroep[] {
  if (maat !== "AANTAL") return groepen;

  // De sleutel is alles ná de eerste as: dat is de reeks waarbinnen wordt opgeteld. Bij één as is
  // die sleutel voor iedereen leeg en telt alles in één lijn op — precies de bedoeling.
  const lopend = new Map<string, number>();
  return groepen.map((g) => {
    const reeks = g.labels.slice(1).join(" ");
    const tot = (lopend.get(reeks) ?? 0) + (g.waarde ?? 0);
    lopend.set(reeks, tot);
    return { ...g, waarde: tot };
  });
}
